// extracted by mini-css-extract-plugin
export default {"AuthorContainer":"AuthorRow_AuthorContainer__C1ksu"};